import { render, staticRenderFns } from "./ViewGame.vue?vue&type=template&id=156296f0&"
import script from "./ViewGame.vue?vue&type=script&lang=js&"
export * from "./ViewGame.vue?vue&type=script&lang=js&"
import style0 from "./ViewGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports